// Un <textarea> no expone dónde quedó el caret en pantalla, así que la única
// forma de anclarle un popup es el truco del div espejo: se crea un div oculto
// que copia la tipografía, el padding, el borde y el ancho del textarea, se le
// mete el texto hasta el caret y se mide dónde arranca el span que sigue.
// Técnica de la librería textarea-caret-position. Los estilos se copian de
// getComputedStyle (no se hardcodean) para que siga funcionando si cambian las
// clases del textarea.
const MIRROR_PROPERTIES = [
    "boxSizing",
    "width",
    "height",
    "direction",
    "borderBottomWidth",
    "borderLeftWidth",
    "borderRightWidth",
    "borderTopWidth",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "tabSize",
    "textAlign",
    "textIndent",
    "textTransform",
    "wordSpacing"
];

const FALLBACK_LINE_HEIGHT = 1.2;

const MINIMUM_LINE_HEIGHT = 16;

function toNumber(value) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
}

function buildMirror(computed) {
    const mirror = document.createElement("div");
    MIRROR_PROPERTIES.forEach((property) => {
        mirror.style[property] = computed[property];
    });
    mirror.style.position = "absolute";
    mirror.style.top = "0";
    mirror.style.left = "0";
    mirror.style.visibility = "hidden";
    mirror.style.overflow = "hidden";
    mirror.style.whiteSpace = "pre-wrap";
    mirror.style.wordWrap = "break-word";
    return mirror;
}

// Devuelve la posición del caret relativa al borde del textarea, o null si la
// medición no se pudo hacer (entorno sin layout real, estilos no resueltos):
// quien llame debe caer a su posición por defecto en ese caso.
export function getCaretCoordinates(input, position) {
    if (!input || typeof window === "undefined") return null;
    if (typeof window.getComputedStyle !== "function") return null;

    const computed = window.getComputedStyle(input);
    const mirror = buildMirror(computed);
    const marker = document.createElement("span");
    const value = input.value || "";

    mirror.textContent = value.slice(0, position);
    marker.textContent = value.slice(position) || ".";
    mirror.appendChild(marker);
    document.body.appendChild(mirror);

    let offsetTop = 0;
    let offsetLeft = 0;
    try {
        offsetTop = marker.offsetTop;
        offsetLeft = marker.offsetLeft;
    } finally {
        document.body.removeChild(mirror);
    }

    if (!offsetTop && !offsetLeft) return null;

    const fontSize = toNumber(computed.fontSize);

    return {
        height:
            toNumber(computed.lineHeight) ||
            fontSize * FALLBACK_LINE_HEIGHT ||
            MINIMUM_LINE_HEIGHT,
        left: offsetLeft + toNumber(computed.borderLeftWidth),
        top: offsetTop + toNumber(computed.borderTopWidth)
    };
}
